import React from 'react'
import {Logo} from '../Common/Logo'
import Slider from 'rc-slider';
import IconButton from 'react-toolbox/lib/button/IconButton'
import {GraphPanel} from '../Common/GraphPanel'

import LogoSVG_White from '../../../images/Bettair_Logo.svg'
import SensorButton from '../../../images/Bettair_SensorButton_Enabled.svg'
import ChartButton from '../../../images/Bettair_ChartButton.svg'
import PlayButton from '../../../images/play.svg'
import PauseButton from '../../../images/pause.svg'

import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';

import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";

import * as SensorsActions from "../../../actions/sensors";
import * as SliderActions from "../../../actions/slider";
import * as AppActions from "../../../actions/app";
import * as AnalyticsActions from "../../../actions/analytics";
import LayerSelector from "./LayerSelector";

const getTime = current => {
    let date = new Date(current);
    let minutes = date.getMinutes();
    let hours = date.getHours();
    if ((hours / 10) < 1)
        hours = "0" + hours;
    if ((minutes / 10) < 1)
        minutes = "0" + minutes;
    return hours + ":" + minutes + "h."
};

const getDate = current => {
    let date = new Date(current);
    return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
};

const handleMapLoop = props => {
    props.map.closePopup();

    if (!props.slider.isLooping) {
        props.analyticsActions.removeAQI();
        props.sliderActions.startSlider();
    } else {
        props.sliderActions.stopSlider();
        props.sensorsActions.fetchSensorsFromTimestamp(props.currentMap, props.heatmaps.display.timestamp);
        if (props.analytics.aqi)
            props.analyticsActions.updateAQI(props.heatmaps.list[props.slider.position].timestamp)
    }
};

const handleAfterChange = props => {
    if (!props.slider.isLooping) {
        if (props.analytics.aqi)
            props.analyticsActions.updateAQI(props.heatmaps.list[props.slider.position].timestamp);
        props.sensorsActions.fetchSensorsFromTimestamp(props.currentMap, props.heatmaps.display.timestamp)
    }

};

const BettAppBar = (props) => {
    const firstTime= props.heatmaps.list[0] ?  getTime(props.heatmaps.list[0].timestamp) : "";
    const lastTime= props.heatmaps.list[props.heatmaps.list.length - 1] ? getTime(props.heatmaps.list[props.heatmaps.list.length - 1].timestamp) : "";
    const currentMapTime= props.heatmaps.display ? getTime(props.heatmaps.display.timestamp) : "";
    const currentMapDate= props.heatmaps.display ? getDate(props.heatmaps.display.timestamp) : "";
    const sensorClassname = "appBarButton " + (props.app.hideSensors ? "": "app_bar_active");
    const chartClassname = "appBarButton " + (props.app.hideChart ? "" : "app_bar_active");
    const play_pause_button = props.slider.isLooping ? PauseButton : PlayButton;

    return (
        <ThemeProvider theme={theme}>
            <div>
                <div className="row">
                    <div className="panelContainer col-lg-12  col-sm-12 col-xs-12 noPadding">
                        <div className="bettAppBar ">
                            <div className="col-sm-2 col-xs-4 noPadding appBarElement appBarLogo">
                                <Logo Logo={LogoSVG_White}/>
                            </div>
                            <div className="col-sm-1 col-xs-2 noPadding appBarElement">
                                <IconButton className={sensorClassname} primary onClick={props.appActions.toggleSensors} > <img className="image-responsive" alt='Show Sensors' src={SensorButton}/> </IconButton>
                            </div>
                            <div className="col-sm-1 col-xs-2 hidden-xs noPadding appBarElement">
                                <IconButton className={chartClassname} primary onClick={props.appActions.toggleChart} ><img  className="image-responsive" alt='Show Chart' src={ChartButton}/></IconButton>
                            </div>
                            <div className="col-sm-1 col-xs-2 hidden-xs noPadding appBarElement">
                                <IconButton className="appBarButton" primary onClick={() => handleMapLoop(props)}><img
                                    className="image-responsive" alt='Auto play' src={play_pause_button}/></IconButton>
                            </div>
                            <div
                                className="col-lg-5 col-md-4 col-sm-4 noPadding  hidden-xs appBarElement sliderElement">
                                <span>{firstTime}</span>
                                <Slider pinned disabled={props.slider.isLooping || props.heatmaps.list.length - 1 < 1}
                                        value={props.heatmapFrame}
                                        defaultValue={props.heatmaps.list.length - 1} min={0} max={props.heatmaps.list.length - 1}
                                        onAfterChange={() => handleAfterChange(props)}
                                        trackStyle={{"background-color": "#3b68f8"}}
                                        onChange={(newPos) => {props.map.closePopup(); props.sliderActions.changeSliderPosition(newPos);}}
                                />



                                <span>{lastTime}</span>
                            </div>
                            <div
                                className="col-md-2 col-sm-3 col-xs-5 noPadding appBarElement mapDataElement noBorder">
                                <div className="col-xs-2 mapDataElementDiv ">
                                    <span className="title">Time</span>
                                    <br/>
                                    <span>{currentMapTime}</span>

                                </div>
                                <div className="col-xs-2 mapDataElementDiv ">
                                    <span className="title">Date</span>
                                    <br/>
                                    <span>{currentMapDate}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {!props.app.hideChart &&
                <div className="row">
                    <div className="graphPanelContainer  col-sm-3 hidden-xs">
                        <GraphPanel
                            aqiMessages={props.analytics.historic.aqi}
                            aqiXAxis={props.analytics.historic.time}
                            IoTsensor={props.app.IoTsensor}
                            noiseMessages={props.noise.value}
                            noiseXAxis={props.noise.time}
                            noiseChart={props.noise.noiseChart}
                        />
                    </div>
                </div>}

                <LayerSelector />
            </div>
        </ThemeProvider>
    )
};


const mapStateToProps = (state) => {
    return {
        slider: state.slider,
        app: state.app,
        heatmaps: state.heatmaps,
        noise: state.noise,
        analytics: state.analytics
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        appActions: bindActionCreators(AppActions, dispatch),
        sensorsActions: bindActionCreators(SensorsActions, dispatch),
        sliderActions: bindActionCreators(SliderActions, dispatch),
        analyticsActions: bindActionCreators(AnalyticsActions, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BettAppBar)



// WEBPACK FOOTER //
// ./src/components/Map/BettAppBar/BettAppBar.js